export const navigation = {
  philosophy: "Philosophie",
  services: "Services",
  training: "Formation",
  credentials: "Références",
  clientele: "Clientèle",
  approach: "Approche",
  contact: "Contact"
};

export const hero = {
  title: "Sécurité Médicale d'Elite",
  subtitle: "Pour les Particuliers Fortunés",
  description: "Fournir une formation médicale d'urgence et des services de réponse inégalés aux familles ultra-fortunées, domaines privés, yachts de luxe et environnements corporatifs exclusifs dans le monde entier.",
  cta: "Planifier une Consultation"
};

export const philosophy = {
  title: "Notre Philosophie",
  subtitle: "Excellence Sans Compromis",
  description: "Nous croyons que les urgences médicales nécessitent une intervention immédiate et experte. Notre philosophie se concentre sur la fourniture du plus haut calibre de formation médicale et de services de réponse d'urgence, adaptés spécifiquement aux clients exigeants qui ne demandent que le meilleur."
};

export const services = {
  title: "Services Principaux",
  subtitle: "Solutions Médicales Complètes",
  cpr_title: "Formation RCP/DEA Avancée",
  cpr_description: "Cours de certification professionnelle conçus pour le personnel domestique, les équipages de yachts et le personnel de sécurité.",
  emergency_title: "Réponse d'Urgence",
  emergency_description: "Services médicaux de réponse rapide 24/7 avec des équipes de paramédics d'élite.",
  consultation_title: "Consultation Médicale",
  consultation_description: "Services de conseil médical expert pour les environnements et activités à haut risque."
};

export const footer = {
  copyright: "© 2024 U First Doctors. Tous droits réservés.",
  phone: "Téléphone",
  email: "Email",
  address: "Adresse"
};